import React, { useEffect, useState } from "react";
import { quizResultWithTime } from "../../../services/QuizService";
import { longAndShortAns } from "../../../services/QuizService";
import ReactHtmlParser from "react-html-parser";
import QuizBar from "./QuizBar";
import moment from "moment";
import { useSelector } from "react-redux";
import SkeletonContainer, { getSkeletonHeight } from "../../../loaders/SekletonContainer";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import axios from "axios";
import { API_BASE, STUDENT_FILE_DOWNLOAD,UPLOAD_ROOT_PATH } from "../../../utils/Constants";
import { ContainerWrapper } from "../../common/GlobalElements/Wrappers";
import { StandardButton } from "../../common/GlobalElements/StandardButton";

export default function ReviewQuiz(props) {
  const { setshow, quizId, rId } = props;
  const user = useSelector((state) => state.user);
  const [quiz, setquiz] = useState({});
  const [maximumLimit, setmaximumLimit] = useState(false);
  const [ansSheet, setAnsSheet] = useState({
    timeArray: [],
    questionArray: [],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    quizResultWithTime({ rid: rId })
      .then((res) => {
        setquiz(res.data[0]);
        setmaximumLimit(res.data[1]);
      })
      .catch((err) => console.log(err));
  }, []);

  const secToMin = (value) => {
    var timestamp = value;
    var hours = Math.floor(timestamp / 60 / 60);
    var minutes = Math.floor(timestamp / 60) - hours * 60;
    var seconds = timestamp % 60;
    var formatted =
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0");
    return formatted;
  };

  useEffect(() => {
    let data = {
      rid: rId,
    };
    setLoading(true);
    longAndShortAns(data)
      .then((res) => {
        setLoading(false)
        setAnsSheet(res.data);
      })
      .catch((err) => {
        console.log(err)
        setLoading(false);
      });
  }, []);

  const date = (value) => {
    const timestamp = new Date(value * 1000);
    return moment(timestamp).format("MM/DD/YYYY h:mm a");
  };


  const handleDocumentDownload = async (submittedFiles) =>{
    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });
    const files = submittedFiles.map(f=> STUDENT_FILE_DOWNLOAD + f.replaceAll(`${UPLOAD_ROOT_PATH}/`, "").replace("public/",""))
    const zip = new JSZip();

    const downloadPromises = files.map(async (fileUrl) => {
      const response = await axios.get(fileUrl, { responseType: 'blob' });
      const fileData = response.data;

      const fileName = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
      zip.file(fileName, fileData);
    });

    await Promise.all(downloadPromises);

    const zipFile = await zip.generateAsync({ type: 'blob' });
    Swal.close();
    saveAs(zipFile, 'files.zip');
  };

  return (
    <div key={rId}>
      <ContainerWrapper class="card card-header-transparent">
        <div class="card-body p-0">
          <div class="form-group" style={{marginBottom:"15px"}}>
            <label className="m-0">
              <strong>
                {user && user.first_name} {user && user.second_name}{" "}
                {user && user.last_name}
              </strong>
            </label>
          </div>

          <div class="table-responsive table__quize__desc">
            <table class="table table-bordered table-striped table-custom-info">
              <tbody>
                <tr>
                  <th>Score</th>
                  <td>
                    {quiz && quiz.score_obtained && ~~quiz.score_obtained}
                  </td>
                </tr>
                <tr>
                  <th>Time Spent (Approx.)</th>
                  <td>{quiz && secToMin(quiz.total_time)} Min.</td>
                </tr>
                <tr>
                  <th>Attempt Time</th>
                  <td>{quiz && date(quiz.start_time)}</td>
                </tr>
                <tr>
                  <th>Percentages</th>
                  <td>
                    {quiz && quiz.percentage_obtained
                      ? ~~quiz.percentage_obtained + "%"
                      : "0%"}
                  </td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>{(quiz && quiz.result_status === "pass") ? "Pass" : "Fail" }</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ContainerWrapper>
      <div class="card card-header-transparent">
        <div class="card-header">
          Time spent on individual question (in seconds)
        </div>
        {loading ? <SkeletonContainer height={getSkeletonHeight(10)} /> : <ContainerWrapper class="card-body">
          <div class="quiz-graph">
            {ansSheet.timeArray.length > 0 && (
              <QuizBar
                timeArr={ansSheet.timeArray[0].split(",")}
                questionArray={ansSheet.questionArray}
                scoreArray={ansSheet.scoreArray}
                dataAns={ansSheet.dataAns}
              />
            )}
          </div>
        </ContainerWrapper>}
      </div>

      {quiz && quiz.view_answer == 1 ? (
        <div class="card card-header-transparent">
          <div class="card-header">Answer Sheet</div>
          {loading ? <SkeletonContainer height={getSkeletonHeight(10)} /> :<ContainerWrapper class="card-body">
            {ansSheet &&
              ansSheet["dataAns"] &&
              ansSheet["dataAns"].map((allAns, i) => {
                var sty = "card card-quiz-answer ";
                if (allAns.questionType === "Document Upload" || allAns.questionType === "Long Answer"){
                  sty += "card-header-yellow";
                } else if(ansSheet.scoreArray[i] === "0"){
                  sty += "card-header-red";
                } else if (
                  allAns.score == ansSheet.scoreArray[i] &&
                  allAns.questionType != "Long Answer"
                ) {
                  sty += "card-header-green";
                } else {
                  sty += "card-header-blue";
                }
                return (
                  <>
                    {(allAns.questionType != "Match the Column" && allAns.questionType !== "Order List") && (
                      <>
                        {/*  */}
                        <div class={sty}>
                          <div class="card-header">Question {i + 1}</div>
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-bordered table-striped table-custom-info">
                                <tbody>
                                  <tr>
                                    <th>Question:</th>
                                    <td>
                                      {ReactHtmlParser(allAns.questionName)}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Your Answer:</th>
                                    <td>
                                      {allAns.questionType === "Document Upload" 
                                        ? <a className="as-text-blue" href="javascript:void(0)" onClick={()=>handleDocumentDownload([...allAns.answerdDocument.map(d=>d.docs)])}>Download Submission</a>
                                        : ReactHtmlParser(allAns.UserAnswer)
                                      }
                                    </td>
                                  </tr>
                                  <tr>
                                    <th>Correct Options:</th>
                                    <td>
                                      {allAns.questionType === "Document Upload" 
                                        ? "-"
                                        : ReactHtmlParser(allAns.correctAnswer)
                                      }
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        {/*  */}
                      </>
                    )}

                    {(allAns.questionType == "Match the Column" || allAns.questionType === "Order List") && (
                      <React.Fragment>
                        {/* ///// */}
                        <div class={sty}>
                          <div class="card-header">Question {i + 1}</div>
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-bordered table-striped table-custom-info table-column-3">
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th>Your Answer</th>
                                    <th>Correct Answer</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{allAns.questionName}</td>
                                    <td>
                                      {/* {ReactHtmlParser(
                                        convertArray(allAns.UserAnswer)
                                      )} */}
                                      {ReactHtmlParser(allAns.UserAnswer)}
                                    </td>
                                    <td>
                                      {/* {ReactHtmlParser(
                                        convertArray(allAns.correctAnswer)
                                      )} */}
                                      {ReactHtmlParser(allAns.correctAnswer)}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        {/* ///// */}
                      </React.Fragment>
                    )}
                  </>
                );
              })}
          </ContainerWrapper>}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
